export default __webpack_public_path__ + "static/media/kopernik.d1ffaa52.jpg";